import React from "react";
import { Box } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import HeaderLogo from "assets/images/GL-Logo.svg";
import Stepper from "components/v3/sharedComponents/Stepper";
import { COLORS } from "components/v3/Theme/colors";
import { PATHS } from "constants/pathConstants";

export interface GiftCheckoutStepperProps {
  activeStepIndex: number;
}

type SubStep = {
  label: string;
  stepIndex: number;
};

type Step = {
  longName: string;
  shortName: string;
  stepIndex: number;
  subSteps: SubStep[];
};

const GiftCheckoutStepper: React.FC<GiftCheckoutStepperProps> = ({
  activeStepIndex
}) => {
  const steps: Step[] = [
    {
      longName: "Add Gift Recipients",
      shortName: "Gift Recipients",
      stepIndex: 0,
      subSteps: []
    },
    {
      longName: "Buy Gift",
      shortName: "Buy Gift",
      stepIndex: 1,
      subSteps: []
    }
  ];

  const greeting = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: (theme) => `calc(${theme.spacing(2)} + 15px)`,
        paddingTop: { md: "15px", xs: "calc(8px + 15px)" },
        width: "100%"
      }}
    >
      <Box
        component={RouterLink}
        to={PATHS.ACCOUNT_MANAGEMENT_GIFT_MEMBERSHIP}
        sx={{
          color: COLORS.PRIMARY,
          fontSize: "0.9375rem",
          fontWeight: 600,
          textDecoration: "none",
          width: "fit-content",
          "&:hover": {
            color: COLORS.PRIMARY_DARK,
            textDecoration: "underline"
          }
        }}
      >
        ← Exit
      </Box>
      <Box sx={{ maxWidth: 175, width: "100%" }}>
        <Box
          alt="Genomic Life"
          component="img"
          src={HeaderLogo}
          sx={{ height: "auto", maxWidth: "100%" }}
        />
      </Box>
    </Box>
  );

  return (
    <Stepper
      activeStepIndex={activeStepIndex}
      greeting={greeting}
      headerShown
      horizontalStripSurface="transparent"
      layout="horizontal"
      showMobileGreeting
      steps={steps}
    />
  );
};

export default GiftCheckoutStepper;
